import { TimeRequestDateTimes } from "utils/interfaces"

export function getValidate(requestTimesSelectors: TimeRequestDateTimes[]) {
    const minCount = 6
    let count = 0

    requestTimesSelectors.forEach((item) => {
        if (item.date && item.time) {
            count += 2
        }
    })

    return count >= minCount
}
